type Props = {
  className?: string;
};

// Brutalist mark: spray-yellow square, 2px black border, "KR" in Syne.
// `className` controls outer sizing — defaults work in most layouts.
export default function Logo({ className }: Props) {
  return (
    <span
      className={
        'inline-flex items-center justify-center bg-spray-yellow text-primary-foreground border-2 border-foreground font-display font-extrabold ' +
        (className ?? 'h-8 w-8 text-xs')
      }
    >
      KR
    </span>
  );
}
